module.exports = __webpack_public_path__ + "assets/img/rateCircle.d9e66952.png";